import styled from '@emotion/styled';
import { Theme } from 'ui_system/theme';

export const ErrorContainer = styled.div`
  padding: 50px;
`;

export const ErrorTitle = styled.h1`
  text-align: center;
  font-family: inherit;
  font-weight: 600;
  color: #333;
  font-size: 24px;
  font-weight: 600;
  line-height: 1;
  margin: 0 0 34px 0;
  position: relative;
`;

export const ErrorPrompt = styled.p`
  text-align: center;
  font-family: inherit;
  font-weight: 400;
  color: #333;
  font-size: 16px;
  margin: 0 0 24px 0;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const RefreshButton = styled.button`
  color: ${Theme.colors.white};
  border: none;
  border-radius: 5px;
  width: 140px;
  height: 44px;
  font-size: 16px;
  background: ${Theme.colors.blue};
  display: flex;
  justify-content: center;
  padding: 13px;
`;

interface TimeSlotCapacityErrorProps {
  errorPrompt: string;
}

export const TimeSlotCapacityError = ({
  errorPrompt,
}: TimeSlotCapacityErrorProps) => {
  return (
    <ErrorContainer>
      <ErrorPrompt>{errorPrompt}</ErrorPrompt>
      <ButtonContainer>
        <RefreshButton type="button" onClick={() => window.history.back()}>
          Refresh
        </RefreshButton>
      </ButtonContainer>
    </ErrorContainer>
  );
};
